<template>
  <div class="course-package">
    <label>课程套餐</label>
    <ul>
      <li v-for="(item, index) in list" :key="index">
        <div class="detail">
          <p class="org-name">
            {{ item.businessName }}
          </p>
          <p
            class="course-name"
            v-for="(course, i) in item.courseList"
            :key="i"
          >
            {{ course.courseName }}({{ course.courseHour }}课时)
          </p>
          <p v-if="item.address" class="address">
            {{ item.address }}
          </p>
        </div>
        <img
          @click="call(item.mobile)"
          src="@/assets/images/icon_order_phone.png"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    call(phone) {
      window.location.href = `tel:${phone}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin.scss';
.course-package {
  background-color: white;
  margin: rem(24px) rem(24px) rem(20px);
  border-radius: rem(16px);
  background-color: #ffffff;
  line-height: 1.2;
  overflow: hidden;
  padding: 0 rem(24px);
  font-size: rem(28px);
  label {
    color: #121212ff;
    font-family: PingFang SC;
    display: block;
    margin-top: rem(32px);
    margin-bottom: rem(24px);
    font-weight: 500;
    font-size: rem(30px);
  }
  ul {
    li {
      padding-bottom: rem(38px);
      padding-top: rem(36px);
      display: flex;
      align-items: center;
      border-bottom: rem(1px) #ededed solid;

      .detail {
        flex: 1;
      }
      > img {
        margin-left: rem(40px);
        width: rem(44px);
        height: rem(44px);
      }
      .org-name {
        color: #121212;
        font-weight: 600;
        font-size: rem(28px);
      }
      .course-name {
        margin-top: rem(16px);
        color: #262626ff;
        line-height: normal;
        font-size: rem(26px);
      }
      .address {
        margin-top: rem(16px);
        color: #999999ff;
        font-size: rem(26px);
        display: flex;
        align-items: center;
        &::before {
          content: '';
          width: rem(28px);
          min-width: rem(28px);
          margin-right: rem(6px);
          height: rem(28px);
          display: inline-block;
          background: url(~@/assets/images/icon_order_address.png) no-repeat;
          background-size: 100%;
        }
      }
    }
    li:first-child {
      padding-top: 0;
    }
    li:last-child {
      border-bottom: 0;
    }
  }
}
</style>
